// extracted by mini-css-extract-plugin
module.exports = {"Root":"lF2BfzWmhxVRyv8a6l6CWQ=="};